import { useTypedParams } from '@sorare/core/src/lib/routing';

import { EnterSeasonalityCompetitionGamesPage } from '@sorare/gameplay/src/pages/EnterSeasonalityCompetitionGamesPage';

import { PageParams } from './__generated__/routeParams';

const NBAEnterSeasonalityCompetitionGamesPage = () => {
  const { fixture, competition, seasonality, trck } =
    useTypedParams<PageParams>();

  return (
    <EnterSeasonalityCompetitionGamesPage
      fixture={fixture}
      seasonality={seasonality}
      competition={competition}
      trck={trck}
    />
  );
};
export default NBAEnterSeasonalityCompetitionGamesPage;
